<template>
  <Popup
    v-model:show="show"
    :style="{
      left: '16px',
      right: '16px',
      width: 'auto'
    }"
  >
    <div class="category-search">
      <div class="category-search__title">
        {{ title }}
        <div
          class="category-search__close"
          @click="show = false"
        >
          <Icon
            name="close-l"
          />
        </div>
      </div>
      <div class="category-search__content">
        <Icon
          class="category-search__icon"
          name="search-l"
        />
        <textarea
          class="category-search__input"
          ref="inputRef"
          @keyup.enter="onEnter"
          v-model.trim="search"
          enterkeyhint="search"
          placeholder="Search within category"
          type="textarea"
          :cols="2"
        />
      </div>
    </div>
  </Popup>
</template>

<script setup>
import { throttle } from '@/utils/utils'
import { useProductList } from '../../hooks/useProductList'
import { retrieveProductList } from '@/api/product'
import { Icon } from '@/components/Icon'
import { Popup } from '@/components/Popup'

const show = defineModel({ type: Boolean, default: false })

defineProps({
  title: {
    type: String,
    required: true
  }
})

const { filter, onReset } = useProductList()

const inputRef = useTemplateRef('inputRef')
const search = ref('')

watch(show, (val) => {
  if (val) {
    nextTick(() => {
      const input = inputRef.value
      if (input) {
        input.click()
        input.focus()
      }
    })
  }
})

watch(search, throttle((cur, pre) => {
  if (cur.length < pre.length) return

  retrieveProductList({
    ...filter,
    keyword: cur,
    pageSize: 50,
    page: 1,
    async: true
  })
}, 400))

const onEnter = () => {
  filter.keyword = search.value
  onReset()
  show.value = false
}
</script>

<style lang="less" scoped>
.category-search {
  border-radius: 12px;
  overflow: hidden;
  background: #FFFFFF;
  left: 16px;
  right: 16px;
  transform: translateY(-50%);

  &__title {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 48px;
    background-color: #F8F8F8;
    border: 1px solid #EBF1F5;
    font-family: mon-600;
    font-size: 14px;
    line-height: 18px;
  }

  &__close {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #F5F5F5;
    border-radius: 50%;
  }

  &__content {
    display: flex;
    gap: 8px;
    padding: 16px 12px 24px;
  }

  &__icon {
    flex-shrink: 0;
    font-size: 20px;
  }

  &__input {
    padding-top: 2px;
    width: 100%;
    border: none;
    font-family: mon-500;
    font-size: 12px;

    &:focus-visible {
      outline:  none;
    }
  }
}
</style>
